import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemTurnipSeeds extends Item {
    constructor() {
        super(definitions.ITEM_ID.TURNIP_SEEDS, texture("prop_turnip_seeds_pouch"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}